import { render, staticRenderFns } from "./WidgetCarouselTextSettings.vue?vue&type=template&id=48c1b741&scoped=true"
import script from "./WidgetCarouselTextSettings.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselTextSettings.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselTextSettings.vue?vue&type=style&index=0&id=48c1b741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1b741",
  null
  
)

export default component.exports